import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import EmailDetailsStructure from "pages/Sales/Inbox/EmailComponents/EmailsDetailsView/EmailDetailsStructure";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import EmailCrmLayout from "./EmailCrm/EmailCrmLayout";
import EmailHistory from "./EmailHistory";
import useInbox from "../InboxTab/InboxContext";

export default function EmailHistoryModalLayout({ hideModal }) {
  const dispatch = useDispatch();
  /* ******************** All States ************************* */
  const {
    fromEmail,
    setFromEmail,
    selectedLabel,
    messageId,
    setMessageId,
    emailsHistoryList: emails,
    setEmailsHistoryList: setEmails,
  } = useInbox();
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [customersList, setCustomersList] = useState([]);
  const [showCrm, setShowCrm] = useState(false);
  // const [emails, setEmails] = useState([]);
  const [searchText, setSearchText] = useState(
    selectedLabel === "SENT"
      ? ` to:${fromEmail} -in:TRASH`
      : `from:${fromEmail} OR to:${fromEmail} -in:TRASH` || "",
  );

  const handleSearch = (e, company) => {
    e.preventDefault();
    setFromEmail(company || searchText);
    if (showCrm) {
      getCustomersList();
    }
  };

  const handleSplitByDomain = (e) => {
    e.preventDefault();

    // Extract From Domain
    const fromEmail = searchText
      .split(" ")
      .filter((part) => part.startsWith("from:"));

    const fromCompany = fromEmail[0]?.split("@")[1];

    // Extract To Domain
    const toEmail = searchText
      .split(" ")
      .filter((part) => part.startsWith("to:"));

    const toCompany = toEmail[0]?.split("@")[1];

    let newSearchText =
      selectedLabel === "SENT"
        ? ` to:@${toCompany} -in:TRASH`
        : ` from:@${fromCompany} OR to:@${toCompany} -in:TRASH`;

    setSearchText(newSearchText);
    handleSearch(e, newSearchText);
  };

  const handleFilterClick = (filter) => {
    let _searchText = searchText || "";
    let filterText = "";

    // Clean Filter
    let cleanedText = _searchText
      .split(" ")
      .filter((part) => !part.startsWith("in:"))
      .join(" ")
      .trim();

    // Append searchText to add label filter eg: in:{filter}
    // if filter == "trash", then remove -in:TRASH from search text
    if (filter === "TRASH") {
      const withoutTrashText = cleanedText?.replace("-in:TRASH", "").trim();
      filterText = withoutTrashText
        ? `${withoutTrashText} in:${filter}`
        : `in:${filter}`;
      setSearchText(filterText);
      setFromEmail(filterText);
      return;
    }
    // If filter === archived_mails then add -in:INBOX -in:TRASH
    else if (filter === "All Mail") {
      if (cleanedText && cleanedText.trim() !== "") {
        // remove -in:INBOX from cleanedText if exists
        if (cleanedText.includes("-in:INBOX")) {
          cleanedText = cleanedText.replace("-in:INBOX", "").trim();
        }

        if (!cleanedText.includes("-in:TRASH")) {
          filterText = `${cleanedText} -in:INBOX -in:TRASH`;
        } else {
          filterText = `${cleanedText} -in:INBOX`;
        }
      } else {
        if (!cleanedText.includes("-in:TRASH")) {
          filterText = `-in:INBOX -in:TRASH`;
        } else {
          filterText = `-in:INBOX`;
        }
      }
    } else if (cleanedText && cleanedText.trim() !== "") {
      // check if -in:TRASH exists in cleanedText
      if (!cleanedText.includes("-in:TRASH")) {
        filterText = `${cleanedText} in:${filter} -in:TRASH`;
      } else {
        filterText = `${cleanedText} in:${filter}`;
      }
    } else {
      filterText = `in:${filter}`;
    }
    setSearchText(filterText);
    setFromEmail(filterText);
  };

  const [loading, setLoading] = useState(false);

  /* ******************** All Functions ************************* */
  const getCustomersList = async () => {
    try {
      setLoading(true);
      const { data } = await API.post(
        "/emails/crm-customers",
        {
          fromEmail: fromEmail,
        },
        { headers: authHeader() },
      );
      if (data?.success) {
        setCustomersList(data.customers || []);
        if (data.customers && data.customers.length > 0) {
          setSelectedCustomer(data.customers[0]);
        } else {
          setSelectedCustomer(null);
        }
      } else {
        throw new Error(data?.message || "Failed to fetch customers");
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  /* ******************** All UseEffects ************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      if (fromEmail && showCrm) {
        getCustomersList();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [fromEmail, showCrm]);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between p-2 bg-white">
        <div className="d-flex align-items-center gap-3">
          {!messageId ? (
            <h4 className="ms-2 mx-1">Search Emails</h4>
          ) : (
            <h4 className="ms-2 mx-1">Email Details</h4>
          )}
          {!messageId && (
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <form onSubmit={handleSearch} className="input-group">
                <input
                  className="form-control"
                  placeholder="To & From"
                  value={searchText}
                  style={{
                    width: 800,
                  }}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <button type="submit" className="btn btn-info">
                  Search
                </button>
                <button
                  type="button"
                  onClick={(e) => {
                    handleSplitByDomain(e);
                  }}
                  className="btn btn-primary"
                >
                  @company
                </button>
              </form>
            </div>
          )}
        </div>
        <div className="d-flex align-items-center gap-3">
          {!messageId && (
            <button
              className="btn btn-primary btn-sm text-nowrap"
              onClick={() => setShowCrm(!showCrm)}
              title={showCrm ? "Hide CRM" : "Show CRM"}
            >
              {showCrm === true ? (
                <>
                  Details
                  <i className="mdi mdi-chevron-right"></i>
                </>
              ) : (
                <>
                  <i className="mdi mdi-chevron-left"></i>
                  Details
                </>
              )}
            </button>
          )}
          {showCrm && (
            <>
              <select
                value={selectedCustomer?.customerId || "no-customer"}
                onChange={(e) => {
                  if (e.target.value === "no-customer") {
                    setSelectedCustomer(null);
                    return;
                  }
                  const customer = customersList.find(
                    (c) => parseInt(c.customerId) === parseInt(e.target.value),
                  );
                  setSelectedCustomer(customer);
                }}
                className="form-control"
              >
                <option value="no-customer">Select Customer</option>
                {customersList.map((customer) => (
                  <option
                    key={customer.customerId}
                    value={customer.customerId}
                    onClick={() => setSelectedCustomer(customer)}
                  >
                    C-{customer.customerId} - {customer.customerName}
                  </option>
                ))}
              </select>
            </>
          )}
        </div>
      </div>
      {/* <hr /> */}
      <div className="rounded-3 py-2 px-2">
        <div className="row">
          <div
            className="col-md-12 pe-1"
            style={{
              minHeight: "78vh",
              maxHeight: "78vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {!messageId ? (
              <div className="d-flex flex-row gap-2 h-100 px-2">
                <div
                  className="flex-grow-1"
                  style={{
                    maxWidth: showCrm ? "66.666666%" : "100%",
                    flexBasis: showCrm ? "66.666666%" : "100%",
                    transition: "all 0.3s ease-in-out",
                  }}
                >
                  <div
                    className="bg-white shadow-sm h-100 p-2 rounded-3"
                    style={{
                      minHeight: "78vh",
                      maxHeight: "78vh",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <EmailHistory
                      emails={emails}
                      setEmails={setEmails}
                      hideModal={hideModal}
                      handleFilterClick={handleFilterClick}
                    />
                  </div>
                </div>
                <div
                  className="position-relative"
                  style={{
                    maxWidth: showCrm ? "33.333334%" : "0%",
                    flexBasis: showCrm ? "33.333334%" : "0%",
                    transition: "all 0.3s ease-in-out",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="d-flex flex-column gap-2 h-100 shadow-sm rounded-3"
                    style={{
                      minHeight: "78vh",
                      maxHeight: "78vh",
                      transform: showCrm ? "translateX(0)" : "translateX(100%)",
                      opacity: showCrm ? 1 : 0,
                      transition:
                        "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
                    }}
                  >
                    {loading && <Spinner />}
                    {showCrm && (
                      <EmailCrmLayout selectedCustomer={selectedCustomer} />
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <>{emails && emails.length > 0 && <EmailDetailsStructure />}</>
            )}
          </div>
        </div>
      </div>
      {/* Buttons */}
      <div className="text-end bg-white p-2">
        <div>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => {
              if (messageId) {
                setMessageId(null);
                return;
              } else {
                hideModal();
              }
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
